<template>
	<div v-if="product">
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title>{{ product.name }}</b-card-title>
                <b-list-group>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('product_label_product_code') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ product.code ? product.code : '-' }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
			</b-col>
		</b-row>
		<b-row class="justify-content-lg-center">
			<b-col>
                <hr />
                <a :href="`/product`" type="button" class="btn btn-secondary">{{ $t('product_button_back_to_list') }}</a>
                <!--
                <a :href="`/product/${product.id}/edit`" type="button" class="btn btn-primary ml-2">{{ $t('product_button_edit') }}</a>
                -->
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'ProductIndex',
    props: ['product'],
}
</script>